import type { HeaterModelFit } from "../../domain/heater/heaterCatalog";
import type { Dictionary } from "../../i18n/types";

/**
 * Renders a catalog heater's room-fit verdict (issue 159) at the UI boundary,
 * or null when the model suits the room.
 */
export function formatHeaterModelFit(
	t: Dictionary,
	fit: HeaterModelFit | undefined,
): string | null {
	if (!fit?.messageKey) return null;
	return t[fit.messageKey]
		.replace("{model}", fit.args.model)
		.replace("{volumeM3}", String(fit.args.volumeM3))
		.replace("{minM3}", String(fit.args.minM3))
		.replace("{maxM3}", String(fit.args.maxM3));
}
